import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache for 5 minutes by default
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Keep cache for 10 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (previously cacheTime)
      // Retry failed requests 2 times
      retry: 2,
      // Don't refetch on window focus by default (mobile app)
      refetchOnWindowFocus: false,
      // Don't refetch on mount if data is fresh
      // (true = refetch only when stale; 'if-stale' is not a valid value)
      refetchOnMount: true,
      // Refetch on reconnect
      refetchOnReconnect: true,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});
